export const vi = {
  common: {
    loadError: 'Không tải được dữ liệu',
    retry: 'Thử lại',
    search: 'Tìm…',
    cancel: 'Huỷ',
    save: 'Lưu',
    saved: 'Đã lưu',
    close: 'Đóng',
    today: 'Hôm nay',
    previous: 'Trước',
    next: 'Sau',
  },
  views: { week: 'Tuần', month: 'Tháng', list: 'Danh sách' },
  calendar: {
    title: 'Lịch của tôi',
    description: 'Cuộc họp bạn tổ chức hoặc được mời.',
    new: 'Tạo họp',
    weekends: 'Hiện cuối tuần',
    allDay: 'Cả ngày',
    empty: 'Không có cuộc họp nào',
    more: '+{{count}} cuộc họp',
  },
  event: {
    new: 'Cuộc họp mới',
    edit: 'Sửa cuộc họp',
    title: 'Tiêu đề',
    date: 'Ngày',
    start: 'Bắt đầu',
    end: 'Kết thúc',
    allDay: 'Cả ngày',
    attendees: 'Người được mời',
    addAttendee: 'Mời thêm người…',
    room: 'Phòng họp',
    noRoom: 'Không đặt phòng',
    roomBusy: 'đang bận',
    busyDays: 'Phòng đã có người đặt vào các ngày: {{days}}',
    location: 'Địa điểm khác',
    meetingUrl: 'Link họp online',
    reminder: 'Nhắc trước',
    reminders: {
      0: 'Không nhắc',
      5: '5 phút',
      10: '10 phút',
      15: '15 phút',
      30: '30 phút',
      60: '1 giờ',
      1440: '1 ngày',
    },
    description: 'Nội dung',
    repeat: 'Lặp lại',
    noRepeat: 'Không lặp',
    frequency: { workday: 'Mỗi ngày làm việc', weekly: 'Hằng tuần', monthly: 'Hằng tháng' },
    weekdays: { 1: 'T2', 2: 'T3', 3: 'T4', 4: 'T5', 5: 'T6', 6: 'T7', 7: 'CN' },
    until: 'Đến ngày',
    busy: 'Bận / rảnh trong ngày',
    busyHint: 'Khung tô màu: người đó đã có họp (không hiện nội dung).',
    organizer: 'Người tổ chức',
    created: 'Đã tạo cuộc họp',
    cancelEvent: 'Huỷ họp',
    cancelConfirm: 'Huỷ cuộc họp này?',
    cancelHint: 'Người được mời sẽ nhận thông báo.',
    cancelled: 'Đã huỷ cuộc họp',
    scopeTitle: 'Áp dụng cho',
    scopeOne: 'Chỉ buổi này',
    scopeFollowing: 'Buổi này và các buổi sau',
    ics: 'Tải file .ics',
    icsHint: 'Thêm vào Google Calendar hoặc Outlook.',
    join: 'Vào họp online',
    series: 'Họp định kỳ',
    myResponse: 'Bạn tham dự?',
    responses: {
      pending: 'Chưa trả lời',
      accepted: 'Tham dự',
      declined: 'Không tham dự',
      tentative: 'Có thể',
    },
    answered: 'Đã gửi phản hồi',
  },
  layers: {
    title: 'Hiện trên lịch',
    leave: 'Ngày nghỉ',
    holiday: 'Ngày lễ',
    task: 'Hạn công việc',
  },
  rooms: {
    title: 'Phòng họp',
    description: 'Lịch các phòng trong ngày. Bấm vào khoảng trống để đặt phòng.',
    manage: 'Quản lý phòng',
    new: 'Thêm phòng',
    edit: 'Sửa phòng',
    name: 'Tên phòng',
    location: 'Vị trí',
    capacity: 'Sức chứa',
    equipment: 'Thiết bị',
    active: 'Đang dùng',
    inactive: 'Ngừng dùng',
    empty: 'Chưa có phòng họp nào',
    emptyHint: 'Quản trị khai báo phòng ở "Quản lý phòng".',
    busy: 'Đã đặt',
    people: '{{count}} người',
  },
  widget: { none: 'Hôm nay không có cuộc họp', open: 'Mở lịch' },
  errors: {
    generic: 'Không thực hiện được. Thử lại sau.',
    'core.validation_failed': 'Thông tin chưa hợp lệ, kiểm tra các trường được đánh dấu.',
    'core.forbidden': 'Bạn không có quyền làm việc này.',
    'calendar.room_busy': 'Phòng đã có người đặt vào giờ này.',
    'calendar.unknown_room': 'Phòng không còn dùng.',
    'calendar.unknown_user': 'Không tìm thấy người được mời.',
    'calendar.not_invited': 'Bạn không có trong danh sách mời.',
    'calendar.cancelled': 'Cuộc họp đã bị huỷ.',
  },
};

export const en: typeof vi = {
  common: {
    loadError: 'Could not load data',
    retry: 'Retry',
    search: 'Search…',
    cancel: 'Cancel',
    save: 'Save',
    saved: 'Saved',
    close: 'Close',
    today: 'Today',
    previous: 'Previous',
    next: 'Next',
  },
  views: { week: 'Week', month: 'Month', list: 'List' },
  calendar: {
    title: 'My calendar',
    description: 'Meetings you organise or are invited to.',
    new: 'New meeting',
    weekends: 'Show weekends',
    allDay: 'All day',
    empty: 'No meetings',
    more: '+{{count}} meetings',
  },
  event: {
    new: 'New meeting',
    edit: 'Edit meeting',
    title: 'Title',
    date: 'Date',
    start: 'Start',
    end: 'End',
    allDay: 'All day',
    attendees: 'Attendees',
    addAttendee: 'Invite someone…',
    room: 'Room',
    noRoom: 'No room',
    roomBusy: 'booked',
    busyDays: 'The room is booked on: {{days}}',
    location: 'Other location',
    meetingUrl: 'Online meeting link',
    reminder: 'Remind',
    reminders: {
      0: 'No reminder',
      5: '5 minutes',
      10: '10 minutes',
      15: '15 minutes',
      30: '30 minutes',
      60: '1 hour',
      1440: '1 day',
    },
    description: 'Agenda',
    repeat: 'Repeat',
    noRepeat: 'Does not repeat',
    frequency: { workday: 'Every working day', weekly: 'Weekly', monthly: 'Monthly' },
    weekdays: { 1: 'Mo', 2: 'Tu', 3: 'We', 4: 'Th', 5: 'Fr', 6: 'Sa', 7: 'Su' },
    until: 'Until',
    busy: 'Busy times that day',
    busyHint: 'Shaded: that person has a meeting (no details shown).',
    organizer: 'Organizer',
    created: 'Meeting created',
    cancelEvent: 'Cancel meeting',
    cancelConfirm: 'Cancel this meeting?',
    cancelHint: 'Attendees will be notified.',
    cancelled: 'Meeting cancelled',
    scopeTitle: 'Apply to',
    scopeOne: 'This meeting only',
    scopeFollowing: 'This and following meetings',
    ics: 'Download .ics',
    icsHint: 'Add it to Google Calendar or Outlook.',
    join: 'Join online',
    series: 'Recurring meeting',
    myResponse: 'Going?',
    responses: {
      pending: 'No answer',
      accepted: 'Going',
      declined: 'Not going',
      tentative: 'Maybe',
    },
    answered: 'Answer sent',
  },
  layers: {
    title: 'Show on the calendar',
    leave: 'Days off',
    holiday: 'Holidays',
    task: 'Tasks due',
  },
  rooms: {
    title: 'Meeting rooms',
    description: "The day's bookings. Click a free slot to book.",
    manage: 'Manage rooms',
    new: 'Add room',
    edit: 'Edit room',
    name: 'Name',
    location: 'Location',
    capacity: 'Capacity',
    equipment: 'Equipment',
    active: 'In use',
    inactive: 'Not in use',
    empty: 'No meeting rooms yet',
    emptyHint: 'Administrators add rooms in "Manage rooms".',
    busy: 'Booked',
    people: '{{count}} people',
  },
  widget: { none: 'No meetings today', open: 'Open calendar' },
  errors: {
    generic: 'Could not complete. Try again later.',
    'core.validation_failed': 'Some information is invalid; check the highlighted fields.',
    'core.forbidden': 'You are not allowed to do this.',
    'calendar.room_busy': 'The room is booked at that time.',
    'calendar.unknown_room': 'The room is no longer in use.',
    'calendar.unknown_user': 'Attendee not found.',
    'calendar.not_invited': 'You are not on the invitation list.',
    'calendar.cancelled': 'This meeting was cancelled.',
  },
};
